<template>
  <div>
    <div class="user-activities-container">
      <div class="profile-holder">
        <img
          v-if="userData && userData.profileUrl"
          v-bind:src="userData.profileUrl"
          alt="Profile image"
        />
        <img
          v-else
          src="../../assets/images/placeholder.png"
          alt="Placeholder profile image"
        />
      </div>
      <div class="name-container">
        <h3>{{ userData.firstName }} {{ userData.lastName }}</h3>
        <p v-if="userData && userData.role">{{ userData.role }}</p>
        <!-- Location Details -->
        <div v-if="(userData && userData.city) || (userData && userData.state)" class="dashboard-profile-user-location">
          <img class="location-icon" src="../../assets/images/location-marker.svg" alt="Location icon" />
          <div>{{getUserLocation}}</div>
        </div>
      </div>

      <!-- Recent Activities Section temporarily disabled below -->

      <!-- <div class="recent-activities">
        <h3>Recent Activities</h3>
        <div class="content-holder">
          <div class="content">
            <img src="../../assets/images/recent-activities-1.png" alt="Recent activity 1" />
            <div class="text">
              <p class="msg">
                Your application has been accepted in 3 vacancies
              </p>
              <p class="time">3h ago</p>
            </div>
          </div>
          <div class="content">
            <img src="../../assets/images/recent-activities-2.png" alt="Recent activity 2" />
            <div class="text">
              <p class="msg">
                Your just applied to a new role
              </p>
              <p class="time">10h ago</p>
            </div>
          </div>
          <div class="content">
            <img src="../../assets/images/recent-activities-3.png" alt="Recent activity 3" />
            <div class="text">
              <p class="msg">
                Your application has been accepted in 3 vacancies
              </p>
              <p class="time">3 days ago</p>
            </div>
          </div>
          <div class="content">
            <img src="../../assets/images/recent-activities-4.png" alt="Recent activity 4" />
            <div class="text">
              <p class="msg">
                Your application has been accepted in 3 vacancies
              </p>
              <p class="time">1 week ago</p>
            </div>
          </div>
        </div>
        <div class="direction-pointer">
          <img src="../../assets/images/arrow.png" alt="Direction pointer" />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserActivities',
  props: ['userData'],
  data() {
    return {
      // userData: {},
    };
  },
  async mounted() {
    // await this.$store.dispatch("fetchUserData");
    // this.userData = await this.$store.state.userData.data;
  },
  computed: {
    getUserLocation() {
      const location = this.userData.city && this.userData.state
      ? `${this.userData.city}, ${this.userData.state}`
      : this.userData.city ? this.userData.city
      : this.userData.state ? this.userData.state
      : null;

      return location;
    },
  },
};
</script>
<style scoped>
  .user-activities-container {
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 350px;
    padding: 0 0.7rem;
  }
  .profile-holder {
    margin: 40px auto;
  }
  .profile-holder img {
    width: 200px;
    height: 200px;
    border-radius: 100%;
    object-fit: cover;
  }
  .name-container {
    /* margin-top: 40px; */
    margin: 40px 0;
    text-align: center;
  }
  .name-container h3 {
    font-family: "montserrat";
    font-weight: 600;
    font-size: 1.563rem;
    line-height: 1.905rem;
    color: rgba(43, 61, 110, 1);
    margin-bottom: 10px;
  }
  .name-container p {
    font-family: "montserrat";
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.524rem;
    color: rgba(135, 135, 135, 1);
  }
  .name-container h3, .name-container p {
    text-transform: capitalize;
  }
  .dashboard-profile-user-location {
    margin-top: 1.438rem;
    color: var(--colorPrimary);
    display: flex;
    font-size: 0.9rem;
    padding: 0 20px;
  }
  .dashboard-profile-user-location img {
    width:20px;
    height:20px;
  }
  .recent-activities {
    /* Hide Recent Activities section until implementation is avvailable */
    /* display: none; */
    padding: 78px 21px 0 21px;
  }
  .recent-activities h3 {
    font-family: "montserrat";
    font-weight: 500;
    font-size: 21px;
    line-height: 26px;
    color: var(--colorSecondary);
    margin-bottom: 49px;
    text-transform: capitalize;
  }
  .recent-activities.content-holder {
    margin-top: 49px;
    position: relative;
  }
  .recent-activities .content {
    display: flex;
    flex-direction: row;
    margin-bottom: 41px;
  }
  .recent-activities .content .text {
    font-family: 'montserrat';
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: #848484;
    margin-left: 18px;
  }
  .recent-activities .content .text .msg {
    margin-bottom: 13px;
  }
  .direction-pointer {
    position: absolute;
    bottom: -20px;
    left: 44%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
    background: var(--colorPrimary);
  }

  @media only screen and (min-width: 1200px) {
    .user-activities-container {
      min-width: 340px; /* set to max-width: 340px when Recent Activities section is enabled */
    }
  }

  @media only screen and (min-width: 990px) {
    /* Review this entire code block when Recent Activities section is enabled */
    .user-activities-container {
      min-height: 570px;
      align-items: center;
      justify-content: center;
    }
  }

  @media only screen and (max-width: 990px) {
    .user-activities-container {
      margin: auto;
      max-width: 100%;
    }
    .dashboard-profile-user-location {
      font-size:12px;
    }
    .dashboard-profile-user-location img {
      width:15px;
      height:15px;
    }
  }

  @media only screen and (max-width: 767px) {
    .user-activities-container {
      display: flex;
      flex-direction: column;
      max-width: unset;
      padding: 0 1rem;
    }
    .chart-and-joblist {
      width: 100%;
    }
    .activities {
      width: 100%;
    }
  }
</style>
